<template>
  <div class="content">
    <h1 class="content__title">Lista de Categorías de Entradas</h1>
    <span class="content__details">Listado de las categorías asignables a las entradas del sitio web</span>
    <div class="content__container">
      <main class="main">
        <section class="main__section">
          <h2 class="main__title">Lista de Categorías</h2>
          <div class="main__results">
            <div class="result" v-if="categories === 'loading'">
              <div class="result__data">
                <img class="result__loading" src="/static/img/waiting.gif" alt="Cargando información">
              </div>
            </div>
            <div class="result" v-else-if="!categories">
              <div class="result__data">
                <h2 class="result__title">No se encontraron resultados</h2>
              </div>
            </div>
            <div class="result" v-else v-for="(category, index) in categories" :key="index">
              <div class="result__data">
                <h2 class="result__title" v-text="'Nombre: ' + category.name_es"></h2>
                <p class="result__detail">Estatus: {{ category.status_id | status(statusList)}}</p>
              </div>
              <div class="result__options">
                <router-link class="btn btn__default btn--small" :to="{name: 'postCategoryEdit', params: {id: category.id}}" > Editar</router-link>
                <button class="btn btn__caution btn--small" @click="deleteCategory(category.id)">Borrar</button>
              </div>
            </div>

          </div>
          <pagination v-if="pagination.pages !== null" :config="pagination"></pagination>
        </section>
      </main>
      <aside class="sidebar">
        <h2 class="sidebar__title">NAVEGACIÓN</h2>
        <router-link class="btn btn--small btn__default" :to="{name: 'postCategoryNew'}">Nueva Categoría</router-link>
      </aside>
    </div>
    <confirmation v-if="confirm" @cancel="confirm = false"></confirmation>
  </div>
</template>

<script>
import httpService from '@/api/request'
import pagination from '@/components/layout/pagination'
import confirmation from '@/components/layout/confirmation'
import {statusList} from './mocks'
export default {
  mixins: [httpService],
  components: {
    pagination,
    confirmation
  },
  data: function () {
    return {
      statusList: statusList,
      categories: 'loading',
      confirm: false,
      pagination: {
        maxButtons: 8,
        results: null,
        pages: null
      },
      maxResults: 12,
      page: 1,
      id: null
    }
  },
  created: function () {
    this.page = this.$route.params.page
    this.getCategories()
  },
  mounted: function () {
    this.$on('continue', () => {
      this.confirm = false
      this.proccedToDelete()
    })
  },
  filters: {
    status: function (id, list) {
      let element = list.filter(item => item.id == id)
      return element[0].name
    }
  },
  watch: {
    '$route.path': function () {
      this.page = this.$route.params.page
      this.getCategories()
    }
  },
  methods: {
    deleteCategory: function (id) {
      this.confirm = true
      this.id = id
    },
    proccedToDelete: function () {
      let httpRequest = {
        module: 'post_categories'
      }
      this.delete(this.id, httpRequest)
        .then(
          () => {
            this.getCategories()
            this.$store.commit('notificate', {
              title: 'CATEGORÍA BORRADA',
              text: 'La categoría ha sido borrada correctamente.',
              type: 'success'
            })
          }
        )
    },
    getCategories: function (filters = '') {
      let httpRequest = {
        module: 'post_categories',
        params: '?limit=' + this.maxResults + '&page=' + this.page + '&embed=pagination' + filters
      }
      this.get(httpRequest)
        .then(
          categories => {
            this.categories = categories.data
            this.pagination.pages = categories.pagination.pages
            this.pagination.currentPage = categories.pagination.current_page
            this.pagination.results = categories.pagination.results
          }
        )
        .catch(
          () => {
            this.categories = null
            this.pagination.pages = null
            this.pagination.currentPage = null
            this.pagination.results = null
            if (this.page > 1) {
              this.$router.push({name: 'postCategoryList', params: {page: this.page - 1}})
            }
          }
        )
    },
    filterByType: function (e) {
      let id = e.target.value
      let filters = ''
      if (id && id > 0) {
        filters = '&type_id=eq:' + id
      }
      this.getCategories(filters)
    }
  }
}
</script>


<style lang="sass" scoped>
@import "../../assets/sass/objects/_btns"
</style>



// WEBPACK FOOTER //
// src/components/post_categories/list.vue